<template>
  <v-container fluid>
    <v-card class="pa-5 mt-3">
      <v-row>
        <v-col cols="6" md="2">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              outlined
              dense
              clearable
              single-line
              hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
              outlined
              hide-details
              @change="refreshTable"
              dense
              persistent-hint
              clearable
              v-model="governorate_id"
              :items="governorates"
              item-text="name"
              item-value="id"
              :label="$t('directorates.governorate')"
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
              outlined
              hide-details
              @change="refreshTable"
              dense
              persistent-hint
              clearable
              v-model="directorate_id"
              :items="directorates_filtered"
              item-text="name"
              item-value="id"
              :label="$t('directorates.directorate')"
          ></v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
              :label="$t('schools.schoolYear')"
              :items="schoolYears"
              outlined
              @change="refreshTable"
              dense
              clearable
              v-model="year_id"
              item-text="school_year"
              item-value="id"
              hide-details
          >
          </v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
              outlined
              dense
              clearable
              hide-details
              persistent-hint
              :items="status"
              item-text="label"
              item-value="value"
              v-model="status_filter"
              @change="refreshTable"
              :label="$t('schoolRenew.status')"
          ></v-select>
        </v-col>  <v-col cols="6" md="2">
        <vue-excel-xlsx
            :data="exportItems"
            :columns="headers.map((i)=>{return {label:i.text, field: i.value}})"
            :file-name="'منصة السراج- طلبات التجديد - '+ (new Date()).toLocaleDateString()"
            :file-type="'xlsx'"
            :sheet-name="'sheet1'"
        >
          <v-btn
              color="primary"
              dark
              class="mb-2"
          >
            {{ $t("export") }}
            <v-icon class="ms-2"> mdi-file-excel</v-icon>
          </v-btn>
        </vue-excel-xlsx>
        </v-col>
      </v-row>
      <v-data-table
          :headers="headers"
          :items="SchoolRenews"
          :loading="loading"
          :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [50, 100, 200, -1]
        }"
          :server-items-length="total"
          :options.sync="options"
          @update:options="refreshTable"
      >
        <template v-slot:[`item.school.name`]="{ item }">
          {{ item.school.name }}
          <v-btn
              v-if="$store.getters.isInRole(101)"
              color="info"
              @click="ViewItem(item)"
              x-small
          >
            التفاصيل
          </v-btn>
          <v-btn
              v-if="$store.getters.isInRole(101)"
              color="#25D366"
              @click="openWhatsapp(item.school)"
              class="ms-1"
              x-small
          >
            واتساب
          </v-btn>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ item.created_at | format_date_time }}
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span v-if="item.status === 'accepted' || item.status === 'rejected'">{{
              item.updated_at | format_date_time
            }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  :color="item.comments && item.comments.length > 0 ? 'warning' : 'dark'"
                  @click="viewItemNote(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                mdi-alert-decagram
              </v-icon>
            </template>
            <span> {{ $t("schoolRenew.note") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip v-if="item.status === 'pending'" color="info" small label>
            {{ $t('schoolRenew.pending') }}
          </v-chip>
          <v-chip v-if="item.status === 'accepted'" color="success" small label>
            {{ $t('schoolRenew.accepted') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'contacted'" color="warning" small label>
            {{ $t('schoolRenew.contacted') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'postponed'" color="cyan" small label>
            {{ $t('schoolRenew.postponed') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'notResponded'" color="teal" small label>
            {{ $t('schoolRenew.notResponded') }}
          </v-chip>
          <v-chip v-else-if="item.status === 'rejected'" color="error" small label>
            {{ $t('schoolRenew.rejected') }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row style="flex-flow: row;">
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="success"
                      @click="changeStatus(item,'accepted')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-check
                  </v-icon>
                </template>
                <span> {{ $t("schoolRenew.accept") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'&& item.status !== 'contacted'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="warning"
                      @click="changeStatus(item,'contacted')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-phone-check-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRenew.contacted") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'&& item.status !== 'postponed'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="cyan"
                      @click="changeStatus(item,'postponed')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-lock-alert-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRenew.postponed") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'&& item.status !== 'notResponded'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="teal"
                      @click="changeStatus(item,'notResponded')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-phone-off-outline
                  </v-icon>
                </template>
                <span> {{ $t("schoolRenew.notResponded") }}</span>
              </v-tooltip>
            </v-col>

            <v-col cols="2" v-if="item.status !== 'accepted' && item.status !== 'rejected'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      color="error"
                      @click="changeStatus(item,'rejected')"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span> {{ $t("schoolRenew.reject") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>


    <confirm-dialog
        :openDialog="dialogAccept"
        :onClicked="updateStatus"
        :payload="'accepted'"
        :dialog-title="$t('schoolRenew.accept')"
        tool-bar-color="success"
        :onClose="closeAll"
    />

    <confirm-dialog
        :openDialog="dialogContacted"
        :onClicked="updateStatus"
        :payload="'contacted'"
        :dialog-title="$t('schoolRenew.contacted')"
        tool-bar-color="warning"
        :onClose="closeAll"
    />

    <confirm-dialog
        :openDialog="dialogPostponed"
        :onClicked="updateStatus"
        :payload="'postponed'"
        :dialog-title="$t('schoolRenew.postponed')"
        tool-bar-color="cyan"
        :onClose="closeAll"
    />

    <confirm-dialog
        :openDialog="dialogNotResponded"
        :onClicked="updateStatus"
        :payload="'notResponded'"
        :dialog-title="$t('schoolRenew.notResponded')"
        tool-bar-color="teal"
        :onClose="closeAll"
    />

    <confirm-dialog
        :openDialog="dialogReject"
        :onClicked="updateStatus"
        :payload="'rejected'"
        :dialog-title="$t('schoolRenew.reject')"
        tool-bar-color="error"
        :onClose="closeAll"
    />
    <note-dialog
        :dialog.sync="dialogViewNote"
        :request="request"
        @refreshTable="refreshTable"
    ></note-dialog>
    <Dialog
        :onClose="closeAll"
        :dialog="dialogView"
        :editedItem="school"
        :editedIndex="editedIndex"
        :valid="valid"
        :resetValidation="resetValidation"
        :directorates="directorates"
        :hide-save="true"
        @refreshTable="refreshTable"
    />
    <dialog
        :dialog.sync="dialogView"
        :school="school"
        @refreshTable="refreshTable"
    ></dialog>

  </v-container>
</template>
<script>
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import NoteDialog from "./NoteDialog.vue";
import Dialog from "../Schools/Dialog.vue";
import {ObjectToQuery} from "@/plugins/helper";
import tr from "vue2-datepicker/locale/es/tr";
import {formatDate} from "@/utils/filter";

export default {
  components: {ConfirmDialog, NoteDialog, Dialog},
  data() {
    return {
      loading: true,
      valid: true,
      dialogReject: false,
      dialogViewNote: false,
      dialogAccept: false,
      dialogContacted: false,
      dialogPostponed: false,
      dialogNotResponded: false,
      dialogView: false,
      status_filter: null,
      governorate_id: null,
      directorate_id: null,
      year_id: null,
      school: null,
      request: null,
      total: 0,
      options: {},
      editedIndex: -1,
      schoolYears: [],
      directorates: [],
      governorates: [],
      search: "",
      rules: {
        required: (value) => !!value || this.$t("ThisFieldIsRequired"),
      },
      SchoolRenews: [],
      editedItem: {
        id: null,
        name: null,
        note: null,
      },
      defaultItem: {
        id: null,
        name: null,
        note: null,
      },
      resetValidation: 0,
    };
  },
  computed: {
    exportItems(){
      return this.SchoolRenews.map((item)=>{
        let newItem = {}
        Object.assign(newItem, item);
        if(newItem.comments && newItem.comments.length > 0){
          newItem.note = newItem.comments[newItem.comments.length -1].comment;
        }
        if (newItem.status !== 'accepted' && newItem.status !== 'rejected'){
          newItem.updated_at = null;
        }
        newItem.created_at = formatDate(newItem.created_at);
        newItem.status = this.$t('schoolRequest.'+item.status)
        return newItem
      });
    },
    tr() {
      return tr
    },
    directorates_filtered() {
      return this.directorates
          .filter(directorate => directorate.governorate_id === this.governorate_id || !this.governorate_id);
    },
    headers() {
      return [
        {text: this.$t("schoolRenew.school_name"), value: "school.name"},
        {text: this.$t("schoolRenew.governorate_id"), value: "governorate.name"},
        {text: this.$t("schoolRenew.directorate_id"), value: "directorate.name"},
        {text: this.$t("schoolRenew.year"), value: "year.school_year"},
        {text: this.$t("schoolRenew.status"), value: "status"},
        {text: this.$t("schoolRenew.created_at"), value: "created_at"},
        {text: this.$t("schoolRenew.updated_at"), value: "updated_at"},
        {text: this.$t("schoolRenew.note"), value: "note"},
        {text: "", value: "actions"},
      ];
    },
    status() {
      return [
        {
          value: 'pending',
          label: this.$t('schoolRenew.pending')
        },
        {
          value: 'accepted',
          label: this.$t('schoolRenew.accepted')
        },
        {
          value: 'rejected',
          label: this.$t('schoolRenew.rejected')
        },
        {
          value: 'contacted',
          label: this.$t('schoolRenew.contacted')
        },
        {
          value: 'postponed',
          label: this.$t('schoolRenew.postponed')
        },
        {
          value: 'notResponded',
          label: this.$t('schoolRenew.notResponded')
        },
      ];
    },
  },
  created() {
    if (!this.$store.getters.isInRole(106)) {
      this.$router.push({name: "notauthorize"});
    }
    this.loading = true;
    this.loadData()
  },
  watch: {
    search: {
      handler() {
        this.refreshTable();
      }
    }
  },
  methods: {
    changeStatus(item, $status) {
      this.editedIndex = this.SchoolRenews.indexOf(item);
      this.editedItem = {
        id: item.id,
        name: item.school.name
      };
      switch ($status) {
        case "accepted":
          this.dialogAccept = true;
          break;
        case "rejected":
          this.dialogReject = true;
          break;
        case "contacted":
          this.dialogContacted = true;
          break;
        case "postponed":
          this.dialogPostponed = true;
          break;
        case "notResponded":
          this.dialogNotResponded = true;
          break;
      }
    },

    ViewItem(item) {
      this.school = item.school;
      this.dialogView = true;
    },
    viewItemNote(item) {
      this.request = item;
      this.dialogViewNote = true;
    },

    closeAll() {
      this.dialogReject = false;
      this.dialogAccept = false;
      this.dialogView = false;
      this.dialogPostponed = false;
      this.dialogContacted = false;
      this.dialogNotResponded = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    updateStatus(status) {
      this.$axios
          .post(`SchoolRenew/${this.editedItem.id}`, {status})
          .then(() => {
            this.refreshTable();
          })
      this.closeAll();
    },
    async loadData() {
      await this.getSchoolYears();
      this.getDirectorates();
      this.GetGovernorates();

    },
    async getSchoolYears() {
      console.log("fetching years")
      await this.$store
          .dispatch("GetYears")
          .then((data) => {
            this.schoolYears = data;
            if (this.schoolYears.length > 0)
              this.selectedSchoolYear = this.schoolYears[0].id;

            this.refreshTable();
          })
          .finally(() => {
            // this.loading = false;
          });
    },
    async getDirectorates() {
      await this.$store
          .dispatch("GetUserDirectorates")
          .then((data) => {
            this.directorates = data;
            // this.directorates.push({
            //   id: null,
            //   name: this.$t("all"),
            // });
          })
          .finally(() => {
            // this.loading = false;
          });
    },
    async GetGovernorates() {
      await this.$store
          .dispatch("GetUserGovernorates")
          .then((data) => {
            this.governorates = data;
          })
          .finally(() => {

          });
    },
    async refreshTable() {

      this.dialog = false;
      this.dialogView = false;
      this.dialogTransfer = false;
      this.dialogReject = false;
      this.loading = true;
      let conditions = {
        ...this.options,
        search: this.search
      };
      if (this.status_filter) {
        conditions.status = this.status_filter;
      }
      if (this.year_id) {
        conditions.year_id = this.year_id;
      }
      if (this.directorate_id) {
        conditions.directorate_id = this.directorate_id;
      }
      if (this.governorate_id) {
        conditions.governorate_id = this.governorate_id;
      }
      const query = ObjectToQuery(conditions);
      await this.$axios
          .get(`SchoolRenew/?${query}`, {noToast: true, failureToast: true})
          .then((response) => {
            this.SchoolRenews = response.data.data.data;
            this.total = response.data.data.total;
          })
          .finally(() => {
            this.$store.dispatch('GetUserAlerts', true);
            this.loading = false;
          });
    },async openWhatsapp(item) {
      this.optionsLoading = true
      try {
        let phone = item.authorized_phone ?? item.manager_phone
        let text = ''
        if (!phone) return;
        phone = phone.replace(/\s+/g, "");
        phone = phone = phone.replace(/[٠-٩]/g, d => "0123456789"["٠١٢٣٤٥٦٧٨٩".indexOf(d)]);
        phone = phone.replace(/^[^\d+]+/, "");
        phone = phone.replace(/^\+?964|^0964|^0/, "")
        phone = phone.replace(/\D/g, "");

        const encodedText = encodeURIComponent(text);
        const waMe = `https://wa.me/${phone}${text ? `?text=${encodedText}` : ''}`;
        const whatsappScheme = `whatsapp://send?phone=${phone}${text ? `&text=${encodedText}` : ''}`;

        const ua = navigator.userAgent || '';
        const isAndroid = /Android/i.test(ua);
        // const isChrome = /Chrome\//i.test(ua) && !/Edge\//i.test(ua);

        // Android Chrome: use intent with explicit fallback URL (cleanest)
        if (isAndroid) {
          const fallback = encodeURIComponent(waMe);
          // intent URL instructs Chrome to open the package, or fallback to browser URL
          const intentUrl = `intent://send?phone=${phone}${text ? `&text=${encodedText}` : ''}#Intent;package=com.whatsapp;scheme=whatsapp;S.browser_fallback_url=${fallback};end`;
          window.location.href = intentUrl;
          return;
        }

        // Otherwise: try opening the whatsapp:// scheme and fallback to wa.me after timeout.
        // Note: browsers may prompt user or block; a user gesture (click) is ideal.
        // Try using location (may open app on mobile)
        try {
          window.location.href = whatsappScheme;
          return;
        } catch (e) {
          // some browsers block direct assignment
        }

        // Fallback to wa.me after small delay.
        // Timeout should be long enough for app to open (e.g. 1.2s). Adjust if needed.
        setTimeout(() => {
          // If user is on desktop, open web.whatsapp in a new tab for better UX
          const isDesktop = !/Mobi|Android|iPhone|iPad|iPod/i.test(ua);
          if (isDesktop) {
            window.open(waMe, '_blank');
          } else {
            // mobile fallback: replace location so back button isn't weird
            window.location.href = waMe;
          }
        }, 1200);
      } finally {
        this.optionsLoading = false
      }
    },
  },
};
</script>
